import * as React from 'react';
import { SetStateAction, useEffect } from 'react';
import * as TFF from '@tff/types/TFF';
import AlternativeFlightCards from './AlternativeFlightCards';
import { AlternativeFlightsFooter } from './AlternativeFlightsFooter';
import BookingCard from '../ConfirmationPage/BookingCard';
import { FlightAlternatives } from '@tff/types/TFF';

interface AlternativeFlightsPageProps {
  journeys: TFF.Journey[];
  isRoundTrip: boolean;
  flightAlternatives?: FlightAlternatives;
  setRebookStep: (value: 'Search' | 'Alternatives' | 'Validate') => void;
  rebookCloser: (fn: SetStateAction<boolean>) => void;
  handleOfferSelection: (offer: TFF.CombinationOffer) => void;
  setSelectedOfferJourneys: (value: SetStateAction<TFF.Journey[]>) => void;
  setGetOffer: (value: SetStateAction<TFF.CombinationOffer | undefined>) => void;
}

const AlternativeFlightsPage: React.FC<AlternativeFlightsPageProps> = ({
  journeys,
  flightAlternatives,
  setRebookStep,
  rebookCloser,
  handleOfferSelection,
  setSelectedOfferJourneys,
  setGetOffer,
  isRoundTrip,
}) => {
  const offers = flightAlternatives?.CombinationOffers || {};
  const firstCombinationOfferId = Object.keys(offers)[0];
  const firstOffer = flightAlternatives?.CombinationOffers?.[firstCombinationOfferId]?.Offers.sort(
    (a, b) => a.TotalAmount - b.TotalAmount,
  )[0];
  const [selectedOffer, setSelectedOffer] = React.useState<TFF.CombinationOffer | undefined>(firstOffer);

  useEffect(() => {
    setGetOffer(selectedOffer);
  }, [selectedOffer]);

  const handleValidationClick = () => {
    if (selectedOffer) {
      handleOfferSelection(selectedOffer);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (firstCombinationOfferId && firstOffer && flightAlternatives?.Journeys) {
      // this is to find and set the Journeys of the first offer
      const outboundJourneyId = firstCombinationOfferId.split('-')[0];
      const outboundJourney = flightAlternatives.Journeys.find(journey => journey.Id === outboundJourneyId);

      if (outboundJourney) {
        const outboundOfferJourney: TFF.Journey = {
          ...outboundJourney,
          CabinClassName: firstOffer.PriceClasses.Journeys[outboundJourney.Id] as TFF.CabinClassName,
        };

        if (isRoundTrip) {
          const inboundJourneyId = firstCombinationOfferId.split('-')[1];
          const inboundJourney = flightAlternatives.Journeys.find(journey => journey.Id === inboundJourneyId);

          if (inboundJourney) {
            const inboundOfferJourney: TFF.Journey = {
              ...inboundJourney,
              CabinClassName: firstOffer.PriceClasses.Journeys[inboundJourney.Id] as TFF.CabinClassName,
            };
            setSelectedOfferJourneys([outboundOfferJourney, inboundOfferJourney]);
          }
        } else {
          setSelectedOfferJourneys([outboundOfferJourney]);
        }
      }
    }
  }, []);

  return (
    <>
      <div className="tff-original-booking">
        <BookingCard journeys={journeys} isOriginalBooking={true} />
      </div>
      <AlternativeFlightCards
        journeys={journeys}
        flightAlternatives={flightAlternatives}
        selectedOffer={selectedOffer}
        setSelectedOffer={setSelectedOffer}
        setSelectedOfferJourneys={setSelectedOfferJourneys}
      />
      <AlternativeFlightsFooter
        setRebookStep={setRebookStep}
        rebookCloser={rebookCloser}
        handleValidationClick={handleValidationClick}
      />
    </>
  );
};

export default AlternativeFlightsPage;
